export default __webpack_public_path__ + "static/media/slice-background-bar-large.c2adcc51.jpg";